export const EVENT_ORDER_ADD_INIT = 'ORDER_ADD_INIT'

export const EVENT_ORDER_UPDATE_INIT = 'ORDER_UPDATE_INIT'

export const EVENT_ORDER_UPDATE_SUCCESS = 'ORDER_UPDATE_SUCCESS'

export const EVENT_ORDER_DETAIL_INIT = 'ORDER_DETAIL_INIT'

export const EVENT_ORDER_DELETE_INIT = 'ORDER_DELETE_INIT'

